import * as axios from 'axios/index';
import { cart } from '../../helpers/routes';
import { API_RESULT } from '../../modules/api';
import timerQueue, { EventType } from '../../helpers/TimerQueue';

const addToCart = productVersionId => {
  return (dispatch, getState) => {
    axios.post('/api/cart', { product_version_option_id: productVersionId }).then(response => {
      const { countryCode } = getState();
      const { data } = response;
      dispatch({ payload: data, type: API_RESULT });
      timerQueue.addEvent({
        callback: () => (window.location = `/${countryCode}${cart}`),
        type: EventType.Navigation,
      });
    });
  };
};

const updateRow = (rowId, productVersionId, quantity) => {
  return dispatch => {
    const payload = {};
    payload[rowId] = {
      product_version_option_id: productVersionId,
      quantity,
    };
    axios.post(`/api/cart/${rowId}`, payload).then(response => {
      const { data } = response;
      dispatch({ payload: data, type: API_RESULT });
    });
  };
};

const deleteRow = rowId => {
  return dispatch => {
    axios.delete(`/api/cart/${rowId}`).then(response => {
      const { data } = response;
      dispatch({ payload: data, type: API_RESULT });
    });
  };
};

export { addToCart, deleteRow, updateRow };
